// Time Analysis Charts Component
// Shows leads by day of week and hour

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Calendar, Clock } from 'lucide-react';
import { 
  BarChart, 
  Bar, 
  AreaChart, 
  Area,
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip, 
  ResponsiveContainer 
} from 'recharts';
import { COLORS } from './analyticsConstants';

export const LeadsByDayChart = ({ timeAnalysis }) => {
  if (!timeAnalysis) return null;

  return (
    <Card className="border-slate-200" data-testid="leads-by-day">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Calendar className="w-5 h-5 text-teal-500" />
          Leads by Day of Week
        </CardTitle>
        <CardDescription>
          Best day: <span className="font-medium text-teal-600">{timeAnalysis.best_day?.day || 'N/A'}</span>
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-48">
          <ResponsiveContainer width="100%" height="100%" minWidth={200} minHeight={200}>
            <BarChart data={timeAnalysis.by_day}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
              <XAxis dataKey="day" tick={{ fontSize: 11 }} />
              <YAxis tick={{ fontSize: 12 }} />
              <Tooltip />
              <Bar dataKey="count" fill={COLORS.primary} radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export const LeadsByHourChart = ({ timeAnalysis }) => {
  if (!timeAnalysis) return null;

  return (
    <Card className="border-slate-200" data-testid="leads-by-hour">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Clock className="w-5 h-5 text-teal-500" />
          Leads by Hour
        </CardTitle>
        <CardDescription>
          Peak hour: <span className="font-medium text-teal-600">{timeAnalysis.best_hour?.hour_label || 'N/A'}</span>
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-48">
          <ResponsiveContainer width="100%" height="100%" minWidth={200} minHeight={200}>
            <AreaChart data={timeAnalysis.by_hour}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
              <XAxis 
                dataKey="hour" 
                tick={{ fontSize: 10 }}
                tickFormatter={(h) => `${h}:00`}
              />
              <YAxis tick={{ fontSize: 12 }} />
              <Tooltip labelFormatter={(h) => `${h}:00`} />
              <Area 
                type="monotone" 
                dataKey="count" 
                stroke={COLORS.primary}
                fill={COLORS.primary}
                fillOpacity={0.3}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};
